// Imports
import DOMPurify from 'dompurify';


// Options
export interface SanitizeOptions {
	/** Tags to be allowed on top of the default allowed tags. */
	extendAllowedTags?: string[];
}


/** Sanitize unsafe HTML */
export default function sanitizeMarkdown(unsafeHTML: string, options?: SanitizeOptions): string {
	return DOMPurify.sanitize(unsafeHTML, { ADD_TAGS: options?.extendAllowedTags });
}
